import { GenericService } from '@/services/api/generic.service';
import { ClinicConfiguration } from '@/models';

export class ClinicConfigurationsService extends GenericService<ClinicConfiguration> {
  constructor(organisationId: string) {
    super();
    this.endpoint = `v1/organisations/${organisationId}/clinic-configurations`;
  }
}
